import { Webhook } from "../common/model/objectTypes";
import { WEBHOOK_INFO, WEBHOOK_PRODUCT_INFO, WEBHOOK_SPECIFICATION } from "../utils/webhook/webhookDescriptions";
import { downloadESignedDocumentBody, returnStatusChangeBody } from "../utils/webhook/webhookObjects";
import { downloadESignedDocumentJsonResponse, returnStatusChangeJsonResponse, testConnectionJsonResponse } from "../utils/webhook/webhookResponseJson";

const downloadESignedDocument : Webhook = {
    name: "Download Esign Document",
    productInfo: WEBHOOK_PRODUCT_INFO.SSR,
    webhookInfo: WEBHOOK_INFO.SSR,
    webhookSpecifications: WEBHOOK_SPECIFICATION.SSR.downloadESignedDocument,
    testConnectionJson: testConnectionJsonResponse,
    responseBody: downloadESignedDocumentBody,
    jsonResponse: downloadESignedDocumentJsonResponse,
}

const returnStatusChange : Webhook = {
    name: "Return Status Changed",
    productInfo: WEBHOOK_PRODUCT_INFO.SSR,
    webhookInfo: WEBHOOK_INFO.SSR,
    webhookSpecifications: WEBHOOK_SPECIFICATION.SSR.returnStatusChange,
    testConnectionJson: testConnectionJsonResponse,
    responseBody: returnStatusChangeBody,
    jsonResponse: returnStatusChangeJsonResponse,
}

export const getContent = (webhookName :string) => {    
    switch (webhookName) {
        case 'Download Esign Document':
            return downloadESignedDocument;
        case 'Return Status Changed':
            return returnStatusChange;
    }
}